import { render, staticRenderFns } from "./AppProfileChangePassword.vue?vue&type=template&id=381a2ed8&scoped=true&"
import script from "./AppProfileChangePassword.vue?vue&type=script&lang=js&"
export * from "./AppProfileChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./AppProfileChangePassword.vue?vue&type=style&index=0&id=381a2ed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a2ed8",
  null
  
)

export default component.exports